var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.10416 12.2319L10.1708 9.45835C10.1783 9.45162 10.1854 9.4445 10.1921 9.43704C10.2991 9.31786 10.2892 9.13448 10.1701 9.02746L7.13942 6.30573C6.87095 6.06463 6.84826 5.65099 7.08872 5.38182C7.32918 5.11265 7.74175 5.0899 8.01021 5.33099L11.8211 8.7534C12.11 9.01285 12.1108 9.46616 11.8228 9.72661L7.97835 13.2036C7.71073 13.4456 7.29809 13.4243 7.05669 13.156C6.81529 12.8876 6.83654 12.4739 7.10416 12.2319Z",
    fill: "#CECECE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.4b2e60dd2a5a5ad232773d3356b51d2e.svg";
export { ForwardRef as ReactComponent };